'use client';

import { type ReactElement } from 'react';
import { Button } from '@/components/ui/button';
import EatalyCategoryPlpFiltersDrawer, {
    type EatalyCategoryPlpFiltersDrawerProps,
} from '@/components/eataly-category-plp-filters-drawer';

export type EatalyPlpFiltersDrawerWithTriggerProps = Omit<EatalyCategoryPlpFiltersDrawerProps, 'trigger'> & {
    triggerTestId: string;
    triggerClassName: string;
    filterButtonAriaLabel: string;
    filterLabel: string;
    selectedFiltersCount: number;
};

export default function EatalyPlpFiltersDrawerWithTrigger({
    open,
    triggerTestId,
    triggerClassName,
    filterButtonAriaLabel,
    filterLabel,
    selectedFiltersCount,
    ...drawerProps
}: EatalyPlpFiltersDrawerWithTriggerProps): ReactElement {
    return (
        <EatalyCategoryPlpFiltersDrawer
            open={open}
            trigger={
                <Button
                    data-testid={triggerTestId}
                    hierarchy="primary"
                    mode="dark"
                    size="small"
                    className={triggerClassName}
                    aria-label={filterButtonAriaLabel}
                    aria-pressed={open}
                    aria-expanded={open}
                    aria-haspopup="dialog">
                    <span>{filterLabel}</span>
                    {selectedFiltersCount > 0 ? (
                        <span className="body-copy-m" aria-hidden>
                            {selectedFiltersCount}
                        </span>
                    ) : null}
                </Button>
            }
            {...drawerProps}
        />
    );
}
